import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from 'react-router-dom';
import axios from 'axios';
import _ from 'lodash';

import OrdersListItem from "../OrdersListItem";
import FilterPane from "../Orders/FilterPane";
import OnMap from "../Orders/SubComponentsRightContent/OnMap";

import { fetchInfo } from "../../actions/";
import { getOrders, getMoreOrders, addLike, addDislike } from "../../actions/orderActions";
import { loginFBUser, getCurrentUser } from '../../actions/session';
import { clearGlobalErrors } from '../../actions/globalErrorActions';

import { whereBallsMove, getHeader, isEmpty } from "../../helper";

import { SetUrlBuild, ParseUrl } from '../Commons/SetUrlBuild';
import { getClientId, getClientSecret } from "../Commons/Constants";

import QRImage from "../../images/mobile_redirect.png";
import IOS from "../../images/ios.png";
import Android from "../../images/android.png";

let headers = {};

class Home extends Component {

    constructor(props) {
        super(props);

        this.state = {
            address: '',
            switchMapList: true,

            filters: {
                q:'',
                latitude: null,
                longitude: null,
                order_date_at: '',
                radius: null,
                orderposition__order_method_type_id: null,
                order_by: "location",
                only_ready_for_contractor: 1
            },
            currentFilters: {
                q: '',
                latitude: null,
                longitude: null,
                order_date_at: '',
                radius: null,
                order_by: 'location',
                orderposition__order_method_type_id: null,
                only_ready_for_contractor: 1
            }
        }

        this.handleChangeAddress = this.handleChangeAddress.bind(this)
        this.handleChangeAddressText = this.handleChangeAddressText.bind(this)
        this.handleChangeDate = this.handleChangeDate.bind(this)
        this.handleSubmit = this.handleSubmit.bind(this)
        this.resetFilters = this.resetFilters.bind(this)
    }

    componentWillMount() {
        const instagramCode = window.location.search.split('code=')[1];

        if(instagramCode) {
            const { history } = this.props;
            let formData = new FormData();

            formData.append('grant_type', 'convert_token');
            formData.append('client_id', getClientId('instagram'));
            formData.append('client_secret', getClientSecret('instagram'));
            formData.append('backend', 'instagram');
            formData.append('token', instagramCode);

            this.props.loginFBUser(
                    formData,
                    () => history.push("/", "home"),
                    (token) => this.props.getCurrentUser(token)
                );
        }

        this.props.fetchInfo([
            {
                query: 'stat-home'
            },
            {
                query: 'camera'
            },
            {
                query: 'order_method_type'
            }
        ]);

        this.props.fetchInfo([
            {
                query: 'settings',
                afterSuccess: () => this.getOrderList(),
                afterError: () => this.getOrderList()
            }
        ]);

        if (this.props.session.isLoggedIn) {
            headers = getHeader()
        }
    }

    getAddressByCoordinates(lat = '55.75393030000001', lng = '37.620795000000044') {
        axios.get(
            `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&sensor=true&key=AIzaSyAG8F_bb70iYVe6mG1i1DQ_KUeaJRLEgNM`)
        .then(response => {
            // console.log("response google", response.data)
            let res = Object.assign([], response.data.results);
            if(res.length) {
                this.setState({
                    address: res[0].formatted_address,
                    currentFilters: {
                        ...this.state.currentFilters,
                        address: res[0].formatted_address,
                    }
                });
            }
        })
        .catch(error => {
            console.error("GetProducts more Error:", error)
        })
    }

    componentDidMount() {
        document.title = 'Fixfact';
        whereBallsMove(1);

        const {session} = this.props;

        if (session.isLoggedIn && navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(function(position) {

                // Get the coordinates of the current possition.
                var lat = position.coords.latitude;
                var lng = position.coords.longitude;

                axios.post(
                    `${window.siteUrl}/api/v1/user/${session.currentUser.id}/set_address/`,
                    {
                        address_latitude: lat,
                        address_longitude: lng
                    },
                    {
                        headers: getHeader()
                    }
                )
                .then(response => {
                    // console.log(response.data)
                })
                .catch(error => {
                    return error;
                });
            });
        }
    }

    componentWillUnmount() {
        this.props.clearGlobalErrors();
    }

    getOrderList () {
        ParseUrl((q, latitude, longitude, order_date_at, radius, order_by, orderposition) => {
            this.setState({
                filters: {
                    ...this.state.filters,
                    q,
                    latitude,
                    longitude,
                    order_date_at,
                    radius,
                    order_by: order_by || this.state.filters.order_by,
                    orderposition__order_method_type_id: orderposition
                }
            }, this.handleSubmit)
        });
    }

    componentWillReceiveProps(nextProps) {
        const { settings } = nextProps.data;
        
        if (settings !== this.props.data.settings) {
            
            this.setState({
                filters: {
                    ...this.state.filters,
                    show_only_near: this.getTimeParam(settings) ? 1 : 2
                }
            })
        }
    }

    getTimeParam(settings) {
        return settings.is_order_timedelta_show_enabled || false;
    }

    handleSubmit(someParams = {}) {
        let {
            q,
            latitude,
            longitude,
            order_date_at,
            radius,
            order_by,
            orderposition__order_method_type_id
        } = this.state.filters;
        const {orderList:{data}} = this.props;

        if(
            !this.state.switchMapList &&
            data.results && data.results.length < 50
        ) {
            someParams = {page_size: 50};
        }

        if(latitude && latitude && this.state.address === '') {
            this.getAddressByCoordinates(latitude, longitude);
        }
        
        SetUrlBuild({
            q,
            latitude,
            longitude,
            order_date_at,
            radius,
            order_by,
            orderposition__order_method_type_id
        });
        this.props.getOrders({uri: 'home', ...this.state.filters, ...someParams}, headers);

        this.setState({
            currentFilters: {...this.state.filters, address: JSON.parse(JSON.stringify(this.state.address))}
        });
    }

    resetFilters(e) {
        e.preventDefault();

        window.history.pushState(null, null, "/");

        this.setState({
            address: '',
            filters: {
                ...this.state.filters,
                q: '',
                latitude: null,
                longitude: null,
                order_date_at: '',
                radius: null,
                order_by: 'location',
                orderposition__order_method_type_id: null
            },
            currentFilters: {
                q: '',
                latitude: null,
                longitude: null,
                order_date_at: '',
                radius: null,
                order_by: 'location',
                orderposition__order_method_type_id: null,
            }
        })
    }


    handleMoreOrders(count) {
        if (!count) return false;

        this.props.getMoreOrders({
            params: {uri: 'home',/*id__lt: id*/ offset: count, ...this.state.filters },
            headers
        });
    }

    handleOnChange(field, value) {
        value = (field === 'orderposition__order_method_type_id' && parseInt(value) === 0)  ? null : value;
        
        this.setState({
            filters: Object.assign({}, this.state.filters, {
                [field]: value
            })
        }, () => console.log('fffff', this.state.filters))
    }

    handleChangeAddressText(address) {
        if (!address.trim()) {
            this.setState({
                filters: Object.assign({}, this.state.filters, {
                    latitude: null,
                    longitude: null
                }),
                address: ''
            });
            return;
        }

        this.setState({address});
    }

    handleChangeAddress(address) {
        this.setState({
            filters: Object.assign({}, this.state.filters, {
                latitude: address.lat,
                longitude: address.lng,
                radius: '10'
            })
        })
    }

    handleChangeDate(date) {
        this.setState({
            filters: Object.assign({}, this.state.filters, {
                order_date_at: date,
                show_only_near: (date.trim() !== "") ? 2 : this.getTimeParam(this.props.data.settings) ? 1 : 2
            })
        })
    }

    handleLike(order) {
        this.props.addLike(order);
    }

    handleDislike(order) {
        this.props.addDislike(order);
    }

    toggleSwitchMapList(value) {
        const {data} = this.props.orderList;
        
        if (value !== this.state.switchMapList) {
            this.setState({ switchMapList: value });

            if(!value && data.results && data.results.length < 50 && data.next) {
                this.handleSubmit({page_size: 50})
            }
        }
    }

    render() {

        const { data, orderList, session } = this.props
        const { order_method_type } = data;
        const { isFetchingMore, isFetching } = orderList;
        const moreOrders = orderList.data.next || null;

        let ffSlogan;
        let createOrderSlogan;
        if(!_.isEmpty(data['settings'])) {
            ffSlogan = data['settings'].home_text_after_word_fixfact;
            createOrderSlogan = data['settings'].home_text_after_button_create_order;
        }
        
        const { mobile_googleplay_url, mobile_appstore_url } = data.settings

        return (
            <div className="vertical-scrolling page firstSection sectionHome" id="sectionHome" data-main-nav-id="homeNavLink">
                <div className="container content">
                    <div className="left-content left-content-width">
                        <div style={{ position: "fixed" }} className="left-content-block">
                            <h1>Fix<span className="text_gradient_violet">Fact</span></h1>
                            {
                                !ffSlogan ? null :
                                <div className="ff-slogan">{ffSlogan}</div>
                            }
                            <ul className="main-advantages">
                                <li><b>{data['stat-home'].count_users_active}</b> активных исполнителей</li>
                                <li><b>{data['stat-home'].count_orders_active}</b> активных заказов</li>
                                <li><b>{data['stat-home'].count_users}</b> исполнителей в системе</li>
                                <li><b>{data['stat-home'].count_orders_period}</b> заданий за последние 30 дней</li>
                            </ul>
                            {
                                session.isLoggedIn
                                    ?
                                    <Link className="big-button" to="/makeorder">
                                        <button className="btn-buy">
                                            Создать заказ
                                        </button>
                                    </Link>
                                    :
                                    <div className="big-button button-action" title="Создать заказ могут только зарегистрированные ползователи">
                                        <button className="disabled" disabled>Создать заказ</button>
                                    </div>
                            }

                            {
                                !createOrderSlogan ? null :
                                <div className="create-order-slogan">{createOrderSlogan}</div>
                            }

                            <div className="qr-block">
                                <img className="qr-block-image" src={QRImage} />
                                <div className="qr-logos" style={{marginLeft:"20px"}}>
                                    <a href = {mobile_appstore_url} style = {{height: '36px', marginBottom: '20px'}} target="_blank">
                                      <img className="qr-logo qr-ios" src={IOS} />
                                    </a>
                                    <a href = {mobile_googleplay_url} style = {{height: '36px', marginBottom: '20px'}} target="_blank">
                                      <img className="qr-logo qr-android" src={Android} />
                                    </a>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div className="right-content right-content-out right-content-width">
                        <div className="screen-outer-block-wrap native-scroll">

                            <FilterPane
                                filterValues={{
                                    ...this.state.filters,
                                    address: this.state.address
                                }}
                                currentFilterValues={{
                                    ...this.state.currentFilters,
                                }}
                                handleOnChange={this.handleOnChange.bind(this)}
                                handleSubmit={this.handleSubmit}
                                resetFilters={this.resetFilters}
                                handleChangeAddress={this.handleChangeAddress}
                                handleChangeAddressText={this.handleChangeAddressText}
                                handleChangeDate={this.handleChangeDate}
                                orderMethodType={order_method_type} />


                            <div className="rounded-white-block screen-bottom-block home-list">
                                <div className="white-block-top header-tabs tab-nav">
                                    <div
                                        className={this.state.switchMapList ? "tab-link active" : "tab-link"}
                                        data-id="tab-content1"
                                        onClick={this.toggleSwitchMapList.bind(this, true)}
                                    >
                                        Список заказов
                                    </div>
                                    <div
                                        className={this.state.switchMapList ? "tab-link" : "tab-link active"}
                                        data-id="tab-content2"
                                        onClick={this.toggleSwitchMapList.bind(this, false)}
                                    >
                                        На карте
                                    </div>
                                </div>

                                {
                                    this.state.switchMapList ?
                                        <ul className="unlimited-block items-list orders-list screen-bottom-block">
                                            {
                                                isFetching ?
                                                <li className="list-item">Загружается...</li>
                                                :
                                                orderList.data.results.length ? orderList.data.results.map((elem, index) =>
                                                    <OrdersListItem
                                                        key={index}
                                                        isLoggedIn={session.isLoggedIn}
                                                        currentUserId={session.currentUser && session.currentUser.id}
                                                        handleLike={this.handleLike.bind(this, elem)}
                                                        handleDislike={this.handleDislike.bind(this, elem)}
                                                        {...elem}
                                                    />
                                                )
                                                : <li className="list-item">Заказов нет</li>
                                            }
                                        </ul>
                                        : <OnMap orders={orderList} />
                                }
                            </div>

                            {
                                moreOrders && !isFetching ?
                                <div className="big-button button-action" style={{ height: "auto", textAlign: "center", marginTop: "30px", marginBottom: "30px" }}>
                                    <button
                                        className={isFetchingMore ? 'disabled btn-more' : 'btn-more'}
                                        onClick={() => this.handleMoreOrders(orderList.data.results.length)}>{isFetchingMore ? 'Загружается...' : 'Загрузить еще'}</button>
                                    {/* onClick={() => this.handleMoreOrders(orderList.data.results.slice(-1)[0].id)}>{isFetchingMore ? 'Загружается...' : 'Загрузить еще'}</button> */}
                                </div>
                                : ''
                            }
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}


const mapStateToProps = state => {
    return {
        ...state
    };
};

export default connect(
    mapStateToProps,
    {
        fetchInfo,
        getOrders,
        getMoreOrders,
        addLike,
        addDislike,
        loginFBUser,
        getCurrentUser,
        clearGlobalErrors,
    }
)(Home);


// WEBPACK FOOTER //
// ./src/components/Home/index.js